import { render, staticRenderFns } from "./UserWantCategory.vue?vue&type=template&id=f359294e"
import script from "./UserWantCategory.vue?vue&type=script&lang=js"
export * from "./UserWantCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports